import { Card } from "@/components/ui/card"
import { userInfo } from "../-data/fixtures"
import RxBarChart from "./chart/rx-bar-chart"
import PrescriptionHub from "./../-components/prescription-hub"
import OnboardingTasks from "./../-components/onboarding-tasks"

export default function Screen() {
  const name = userInfo.name
  return (
    <div className="h-full overflow-y-auto pb-12">
      <Card className="border-0 shadow-none bg-transparent">
        <div className="pt-2 pb-4">
          <h1 className="text-3xl font-semibold">
            How is it going, <span className="text-black/50">{name}</span>?
          </h1>
          <p className="text-muted-foreground">Here’s a quick look at how things are going.</p>
        </div>
      </Card>
      <div className="space-y-4">
        <RxBarChart />
        <div className="grid grid-cols-2 gap-4 max-[780px]:grid-cols-1">
          <PrescriptionHub />
          <OnboardingTasks />
        </div>
      </div>
    </div>
  )
}